export default {
    ready: () => {

        $('.tour-reading-list')
            .on('click', '.btn-open', function(){
                var $container = $(this).closest('.tour-reading-list'),
                    $books = $container.find('.tour-books');

                $books.slideDown(400, function(){
                    $container.removeClass('collapsed');
                });
            })

            .on('click', '.btn-close', function(){
                var $container = $(this).closest('.tour-reading-list'),
                    $books = $container.find('.tour-books');

                $books.slideUp(400, function(){
                    $container.addClass('collapsed');
                });
            });
    },
};
